import React from 'react'

import logo_white from "../assets/img/logo-white.svg";
import icon_phone from "../assets/img/icon-phone.svg";
import icon_email from "../assets/img/icon-email.svg";
import fb from "../assets/img/fb.svg";
import inst from "../assets/img/inst.svg";
import tw from "../assets/img/tw.svg";

import "../assets/css/footer.css";

const Footer = () => {
  return (
    <footer className="footer" >
        <div className="footer__container container">
          <section className="footer__newsletter">
            <h2 className="footer__title">Newsletter</h2>
            <p className="footer__paragraph ">  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris nulla quam, hendrerit lacinia 
              vestibulum a, ultrices quis sem.</p>
              <form className="footer__form">
                <input type="email" className="footer__input" />
                <input type="submit" className="footer__cta" value="Subscribe" />
              </form>
          </section>
          <section className="footer__content">
            <img src={logo_white} alt="" className="footer__logo" />
            <p className="footer__paragraph">Lorem ipsum dolor sit amet consectetur adipisicing elit. Nostrum quis maxime voluptatem doloremque praesentium architecto voluptate consectetur libero id alias?</p>
            <div className="footer__contact">
              <img src={icon_phone} alt="" className="footer__img" />
            </div>
            <div className="footer__contact footer--email">
              <img src={icon_email} alt="" className="footer__img" />
            </div>
            <div className="footer__social">
              <a href="www.google.com" className="footer__link">
                <img src={fb} alt="" className="footer__icon" />
              </a>
              <a href="www.google.com" className="footer__link">
                <img src={inst} alt="" className="footer__icon" />
              </a>
              <a href="www.google.com" className="footer__link">
                <img src={tw} alt="" className="footer__icon" />
              </a>
            </div>
          </section>
        </div>
      </footer>
  )
}

export default Footer